import classNames from 'classnames'
import React from 'react'
import style from './styles/button.module.scss'

const PlayButton = ({ onClick, className = '' }): React.ReactElement => {
  return (
    <button
      type='button'
      className={classNames({
        [style.video]: true,
        [className]: Boolean(className)
      })}
      onClick={onClick}
    >
      <svg
        width='60'
        height='60'
        viewBox='0 0 60 60'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <rect width='60' height='60' rx='30' fill='#FF0000' />
        <path
          d='M44.1862 28.3107L22.5182 15.2376C22.2653 15.085 21.977 15.0031 21.6827 15.0001C21.3884 14.9971 21.0985 15.0732 20.8427 15.2207C20.5868 15.3681 20.374 15.5816 20.226 15.8395C20.078 16.0974 20 16.3904 20 16.6888V42.312C20.0003 42.6077 20.0772 42.8981 20.2229 43.1542C20.3686 43.4104 20.5781 43.6233 20.8304 43.7717C21.0827 43.9201 21.369 43.9988 21.6607 44C21.9524 44.0012 22.2393 43.9247 22.4927 43.7784L44.1606 31.2284C44.4134 31.0819 44.6239 30.8708 44.7712 30.6162C44.9185 30.3615 44.9974 30.0722 44.9999 29.7771C45.0025 29.4819 44.9287 29.1912 44.7859 28.9339C44.6431 28.6767 44.4363 28.4619 44.186 28.3109L44.1862 28.3107ZM22.2215 41.342V17.679L42.2316 29.7519L22.2215 41.342Z'
          fill='currentColor'
        />
      </svg>
    </button>
  )
}

export default PlayButton
